export const initState = {
	$list: [],

	sendConfigEdit: null,
	_status: 'init',

	filteredConfigList: [],

	turnRule: '',
	turnDoc: '',

	turn: {
		_turnStatus: 'init',
		turnSelectedSymbol: '',
		turnRuleValue: '',
		turnDocumentValue: '',
	},
};

export default initState;
